// global js error handler

const debug = false;
const uncaught = require('uncaught');
let errorCount = 0;


uncaught.start();
uncaught.addListener(error => {
    if (!error)
        return;

    if (navigator.userAgent && (navigator.userAgent.includes('MiuiBrowser') || navigator.userAgent.includes('Jooblebot')))
        return;     // buggy browsers/robots

    errorCount++;
    console.log(`Uncaught error or promise rejection #${errorCount}:`, error);

    if (errorCount > 2) {
        console.warn(`max uncaught error count (${errorCount}) reached - aborting error reporting`);
        return;
    }

    if (typeof base_url === 'undefined')
        base_url = '/';

    const $docHTML = jQuery('html')
        .remove('script')
        .html()
        .replace(/(src|href)="\//gi, `$1="${base_url}`);   // relative -> absolute links

    const coreJSError = (typeof error === 'object' && typeof error['stack'] === 'string') ? error.stack.replace(/\r\n|\r|\n/g, '<br> &nbsp;') : '';   // newline to <br> = error.stack.replace(/\r\n|\r|\n/g, '<br> &nbsp;');   // newline to <br>
    let devErrorMessage =  `<p>An uncaught javascript error was detected (<strong>error.stack</strong>):</p>
                            <pre style="color: #f04124">${coreJSError}</pre>
                            <br>
                            <p><strong>error.message</strong>:</p>
                            <pre style="color: #f04124">${error.message}</pre>
                            <p><strong>on page</strong>: ${window.location.href},
                            <br><strong>browser</strong>: ${navigator.userAgent || 'unknown'}</p>`;

    // send the error to the server (in development environment, the server will reject it resulting in a local popup)
    if (window.environment === 'development')
        dialog.open({ title: 'Uncaught Error', source: devErrorMessage, persistent: true }).then();   // local error display
    else {
        jQuery.post('/messaging/sendJsErrorReport', { errorMessage: devErrorMessage, screenshot: $docHTML })
            .done(function () {
                if (debug) console.debug('An uncaught js error was successfully sent to the server');
            }).fail(function () {
                console.error(`An uncaught js error failed to reach the developer!`);
            });
    }

});